import ActionTypes from "../actions/actionTypes";

export function dtmf(str) {
  return (dispatch, getstate) => {
    if (!str) return;
    if (!str.length === 1) return;

    var regex = new RegExp("^[01234567890*#]$");
    if (!regex.test(str)) return;

    if (getstate().sip.session) {
      getstate().sip.session.dtmf(str);
    }

    dispatch({
      type: ActionTypes.CALL_DTMF,
      payload: str,
    });
  };
}






// WEBPACK FOOTER //
// ./src/actions/dtmfActions.js